import "regenerator-runtime/runtime";
import _asyncToGenerator from "I:\\lcy\\\u5DE5\u4F5C\\\u7F51\u7AD9\\\u672A\u5B8C\u6210\\\u4E09\u624D\u91C7\u7F16\\\u793A\u8303\u7AD9\u70B9new\\aliyun\\samsonwebfinal\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var timeStop;
export default {
  name: "Login_WeiXin",
  data: function data() {
    return {
      src: "",
      carousel: "",
      Code: "",
      timeStop: "",
      pwdFalseShow: false
    };
  },
  props: ['dialogVisible', "type"],
  deactivated: function deactivated() {
    window.clearInterval(timeStop);
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var carousel;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.dispatch("_getGetQrcode");

            case 2:
              carousel = _context.sent;

              if (carousel) {
                this.src = carousel.data.Url;
                this.Code = carousel.data.Code;
                this.handleQrcodeCheck(this.type);
                this.$parent.loading = false;
                this.$emit('func', this.src);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    handleQrcodeCheck: function handleQrcodeCheck(type) {
      var _this = this;

      //        if(type==2){
      //            let  appid = "wxdcaadfbc36ca5584";
      //   let redirect_uri = encodeURIComponent('http://beta.samsoncn.com')
      //   window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATUS#wechat_redirect`
      //        }else
      if (type == 1) {
        timeStop = window.setInterval(function () {
          _this.$store.dispatch("_getWeiXinLogin", {
            Scene: _this.Code
          }).then(function (res) {
            if (res.data.IsSuccess) {
              if (!res.data.Data.IsGo) {
                _this.pwdFalseShow = true;
                return;
              }

              _this.$message({
                message: "登录成功",
                type: "success"
              });

              localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
              var urldomain = "/";
              window.location.href = urldomain;

              _this.$emit('fuab', false);
            }
          });
        }, 2000);
      }
    }
  }
};